import { Checkbox, FormControlLabel, Stack } from "@mui/material";
import React from "react";
import { CheckoutFormTypeFields, useCheckoutForm } from "./hooks/useCheckoutForm";
import { OrderDeliveryAddressFields } from "../../types/purchaseOrder/Order";
import { SectionTitle } from "./SectionTitle";
import { AddressFields } from "./AddressFields";

export const DeliveryAddressInformationSection: React.FC = () => {
    const { methods } = useCheckoutForm();

    const sameDelivery = methods.watch(CheckoutFormTypeFields.SameDeliveryAddress) ?? true;

    const handleSameChange = (_: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        methods.setValue(CheckoutFormTypeFields.SameDeliveryAddress, checked, {
            shouldValidate: false,
        });
        if (checked) {
            methods.clearErrors(CheckoutFormTypeFields.ShippingAddress as any);
        } else {
            const billingZip = methods.getValues(
                `${CheckoutFormTypeFields.DeliveryAddress}.${OrderDeliveryAddressFields.ZipCode}` as any,
            );
            if (billingZip) {
                methods.setValue(
                    `${CheckoutFormTypeFields.ShippingAddress}.${OrderDeliveryAddressFields.ZipCode}` as any,
                    billingZip,
                    { shouldValidate: false },
                );
            }
        }
    };

    return (
        <Stack mb={2} spacing={2}>
            <Stack>
                <SectionTitle>Domicilio</SectionTitle>
                <AddressFields
                    control={methods.control}
                    baseName={CheckoutFormTypeFields.DeliveryAddress}
                />
                <FormControlLabel
                    sx={{ mt: 1.5 }}
                    control={
                        <Checkbox checked={sameDelivery} onChange={handleSameChange} size="small" />
                    }
                    label="¿Mismo domicilio de entrega?"
                />
            </Stack>

            {!sameDelivery && (
                <Stack>
                    <SectionTitle>Domicilio de Entrega</SectionTitle>
                    <AddressFields
                        control={methods.control}
                        baseName={CheckoutFormTypeFields.ShippingAddress}
                        showCP={false}
                    />
                </Stack>
            )}
        </Stack>
    );
};
